import { createFileRoute } from "@tanstack/react-router";

import Confetti from "@repo/icons/colored/Confetti";

import oldDoctorWithPatient from "@/assets/old-doctor-with-patient.webp";
import { Button } from "@/components/ui/button/button";
import { ImageDrawerLayout } from "@/components/ui/layout/image-drawer/image-drawer-layout";
import { useReturnToNavigation } from "@/hooks/use-return-to-navigation";

import type { JSX } from "react";

const PasswordChangedPage = (): JSX.Element => {
  const { navigateToReturnToOrFallback } = useReturnToNavigation();

  const handleAccessAccount = (): void => {
    navigateToReturnToOrFallback("/auth/signin");
  };

  return (
    <ImageDrawerLayout>
      <ImageDrawerLayout.Image>
        <img
          src={oldDoctorWithPatient}
          alt="Médica cumprimentando paciente no consultório"
          className="object-top"
        />
      </ImageDrawerLayout.Image>

      <ImageDrawerLayout.Drawer>
        <Confetti size={80} className="fill-primary-400" aria-hidden="true" />

        <ImageDrawerLayout.Content>
          <ImageDrawerLayout.Title>Senha alterada com sucesso</ImageDrawerLayout.Title>
          <ImageDrawerLayout.Description>
            Você já pode acessar sua conta com a nova senha.
          </ImageDrawerLayout.Description>
        </ImageDrawerLayout.Content>

        <Button fullWidth color="secondary" onClick={handleAccessAccount}>
          Acessar minha conta
        </Button>
      </ImageDrawerLayout.Drawer>
    </ImageDrawerLayout>
  );
};

export const Route = createFileRoute("/auth/password-reset/password-changed")({
  component: PasswordChangedPage,
});
